export const createRequestOptions = (requestOptions: Partial<Api.ClientRequestOptions> = {}): Api.ClientRequestOptions => {
	requestOptions = { ...requestOptions };
	requestOptions.loadingEl ??= globalThis.document?.body;
	requestOptions.loadingShowSpinner ??= true;
	requestOptions.method ??= 'POST';
	requestOptions.accept ??= 'application/json';

	return requestOptions as Api.ClientRequestOptions;
};
